export default {
  name: 'MainLayout'
};